<style>

.dialog{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #333;
  z-index: 200;
  border-radius: 15px 15px 0 0;
  overflow-y: auto;
  color: white;
}

.handle{
  height: 6px;
  width: 60px;
  margin: 15px auto;
  background-color: #ccc;
  border-radius: 5px;
}

.title{
  font-size: 25px;
  text-align: center;
}

.body{
  padding: 5px;
}

.accept{
	text-align: center;
}

.buttons{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 201;
  background-color: #333;
  height: 54px;
}
.has-buttons{
  height: 53px;
}
button:first-child{
  width: 48%;
  border: 0;
}
button{
  width: 48%;
  border: 0;
  padding: 10px 0;
  font-size: 26px;
  border-left: 1px #777 solid;
  color: #ccc;
}
button:hover{
  background-color: inherit;
}
button:disabled{
  color: #999;
  background-color: inherit;
}

hr.divider{
  margin: 0;
  border: 0;
  border-top: 1px #777 solid;
}
hr.divider-margin{
  margin-bottom: 10px;
}


</style>

<svelte:window bind:innerHeight={clientHeight}/>

{#if show == true}

<div class="dialog" style="height: {finalHeight}px" in:fly="{{y: finalHeight }}" out:fade="{{duration: 200}}">
  
  <div class="handle"></div>
  <div class="title">{title}</div>
  
  <div class="body">
    <slot></slot>
  </div>
  
  <div class="has-buttons"></div>
  
  <div class="buttons">
    <hr class="divider">
    
    <div>
      <div class="accept">
        {#each buttons as item}
        <button on:click="{ () => {dispatch(item.callback)} }" disabled="{item.disabled}">{item.text}</button>
        {/each}
      </div>
    </div>
  </div>
    
</div>


{/if}

<script>

import { fly, fade } from 'svelte/transition';

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let show = false;
export let title = "Slide Dialog";
// [ {text: 'send', callback: 'send', disabled: false, }, 
// {text: 'send2', callback: 'send2', disabled: false, }, ]
export let buttons = [];
export let height = 0; // can be number or 100%

let finalHeight = 400;
let clientHeight = 0;

import { onMount } from "svelte";
onMount(async () => {
  set();
});


$:{
  // watch height for changes
  if (height) set();
}


function set() {
  if (height == "100%") {
    finalHeight = clientHeight - 10;
  } else if ( typeof height == "number" ) {
    finalHeight = height;
  } else {
    console.log("height incorrectly set - setting to default 400px");
  }
}

</script>